// extracted by mini-css-extract-plugin
export default {"trigger_reset":"page_password_reset_trigger_reset__YzZS5","message_ack":"page_password_reset_message_ack__VBYYp","message_error":"page_password_reset_message_error__W0Sjx"};